var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterIcon21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.64184 0.721449C6.64184 0.956676 6.75253 2.29193 6.8148 2.86617L6.85631 3.19825H3.42476H0.000137009V3.35046C-0.00678143 3.4404 0.249201 6.7059 0.567449 10.6148L1.13476 17.727H4.57322H8.00477L8.0532 18.2251C8.08087 18.5018 8.12238 18.7509 8.15006 18.7786C8.17773 18.8062 10.1841 19.9962 12.6124 21.4214L17.0195 24.0089L21.4265 21.4214C23.848 19.9962 25.8543 18.8132 25.8889 18.7786C25.9166 18.7509 25.9581 18.5018 25.9858 18.2251L26.0342 17.727H29.4658H32.9042L33.4715 10.6148C33.7898 6.7059 34.0458 3.4404 34.0389 3.35046V3.19825H30.6142H27.1827L27.2242 2.86617C27.2865 2.29193 27.3972 0.956676 27.3972 0.721449V0.500059H17.0195H6.64184V0.721449ZM7.01543 5.56436C7.05694 5.78575 7.81797 15.2502 7.81797 15.4716C7.81797 15.5684 7.58966 15.5823 5.4657 15.5823C4.17196 15.5823 3.11343 15.5615 3.11343 15.5269C3.11343 15.4231 2.35932 6.05556 2.31781 5.70272L2.28322 5.34297H4.62857H6.98084L7.01543 5.56436ZM31.7212 5.66813C31.6866 5.95179 30.9256 15.4162 30.9256 15.5407C30.9256 15.5615 29.867 15.5823 28.5733 15.5823C26.7399 15.5823 26.221 15.5615 26.221 15.4923C26.221 15.3055 26.989 5.77883 27.0236 5.56436L27.0581 5.34297H29.4104H31.7627L31.7212 5.66813Z",
    fill: "url(#paint0_linear_402_1472)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.076 27.5511V31.0795H17.0195H20.963V27.5511V24.0157L20.8108 24.0988C20.7209 24.1472 19.8353 24.6592 18.839 25.2472L17.0264 26.3196L15.2069 25.2472C14.2037 24.6592 13.3181 24.1472 13.2351 24.0988L13.076 24.0157V27.5511Z",
    fill: "url(#paint1_linear_402_1472)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76578 34.4488C8.54439 35.2029 8.37143 35.8394 8.37143 35.8671C8.37143 35.9362 25.6675 35.9362 25.6675 35.8671C25.6675 35.8394 25.4946 35.2029 25.2732 34.4488L24.8788 33.0858H17.0195H9.16013L8.76578 34.4488Z",
    fill: "url(#paint2_linear_402_1472)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_402_1472",
    x1: 17.0195,
    y1: 24.0089,
    x2: 17.0195,
    y2: 0.500059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4394F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54C0FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_402_1472",
    x1: 17.0195,
    y1: 31.0795,
    x2: 17.0195,
    y2: 24.0157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4394F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54C0FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_402_1472",
    x1: 17.0195,
    y1: 35.9189,
    x2: 17.0195,
    y2: 33.0858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4394F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54C0FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon21);
export default __webpack_public_path__ + "static/media/footer_icon_2_1.68128dd44a4469be3d97d99f7147c115.svg";
export { ForwardRef as ReactComponent };